/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Project_Import_FailedInputs */

const en_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to import team project. ${i?.message}`)
};

const fr_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’importation du projet d’équipe. ${i?.message}`)
};

const de_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teamprojekt konnte nicht importiert werden. ${i?.message}`)
};

const it_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile importare il progetto del team. ${i?.message}`)
};

const ru_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать командный проект. ${i?.message}`)
};

const es_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar el proyecto del equipo. ${i?.message}`)
};

const zh_cn2_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`团队项目导入失败。${i?.message}`)
};

const ja_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`チームプロジェクトのインポートに失敗しました。${i?.message}`)
};

const hi_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट आयात करने में विफल। ${i?.message}`)
};

const pt_pt2_team_project_import_failed = /** @type {(inputs: Team_Project_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao importar o projeto da equipe. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to import team project. {message}" |
*
* @param {Team_Project_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_failed = /** @type {((inputs: Team_Project_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_failed(inputs)
	if (locale === "de") return de_team_project_import_failed(inputs)
	if (locale === "it") return it_team_project_import_failed(inputs)
	if (locale === "ru") return ru_team_project_import_failed(inputs)
	if (locale === "es") return es_team_project_import_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_failed(inputs)
	if (locale === "ja") return ja_team_project_import_failed(inputs)
	if (locale === "hi") return hi_team_project_import_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_failed(inputs)
	return en_team_project_import_failed(inputs)
});